import { DeferLoadingStrategy } from '@spartacus/core';
import { LayoutConfig } from '@spartacus/storefront';

export const layoutConfig: LayoutConfig = {
  deferredLoading: {
    strategy: DeferLoadingStrategy.DEFER,
    intersectionMargin: '50px'
  },
  breakpoints: {
    xs: 390,
    sm: 744,
    md: 1024,
    lg: 1280,
    xl: {
      min: 1440
    }
  },
  layoutSlots: {
    header: {
      lg: { slots: ['SiteLogo', 'SiteLogin', 'MiniCart', 'PreHeader', 'SearchBox'] },
      xl: { slots: ['SiteContext'] },
      slots: ['SiteLogo', 'SiteLogin', 'MiniCart', 'PreHeader', 'SearchBox']
    },
    navigation: {
      lg: { slots: ['SiteContext', 'NavigationBar'] },
      xl: { slots: ['SiteLogo', 'SearchBox', 'SiteLogin', 'MiniCart', 'NavigationBar'] },
      slots: ['SiteContext', 'NavigationBar']
    },
    ContentPage1Template: {
      slots: ['Section1', 'Section2A', 'Section2B', 'Section3', 'Section4', 'Section5']
    },
    ProductListPageTemplate: {
      slots: ['TopContentSlot', 'ProductLeftRefinements', 'ProductListSlot']
    },
    ProductDetailsPageTemplate: {
      slots: ['Summary', 'ProductFeature', 'UpSelling', 'CrossSelling', 'Tabs', 'PlaceholderContentSlot']
    },
    AccountPageTemplate: {
      slots: ['TopContent', 'BodyContent', 'SideContent']
    },
    SearchResultsEmptyPageTemplate: {
      slots: ['TopContent', 'MiddleContent', 'SideContent']
    },
    OverviewPageTemplate: {
      slots: ['Overview', 'Section1', 'Section2A', 'Section2B', 'Section3']
    },
    NewsPageTemplate: {
      slots: ['NewsDetails', 'Section1', 'Section2A', 'Section2B', 'Section2C', 'Section3', 'Section4', 'Section5']
    },
    StoreFinderPageTemplate: {
      slots: ['SideContent', 'MiddleContent']
    }
  }
};
